module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 817
// module chunks = 3